// extracted by mini-css-extract-plugin
export default {"delete":"PostDelete_delete__GSk2Z"};